import posthog from "posthog-js";
import { posthogConfig } from "../config";

class PostHogService {
  constructor() {
    this.initialized = false;
  }

  init() {
    if (this.initialized || !posthogConfig.apiKey) {
      return;
    }

    posthog.init(posthogConfig.apiKey, {
      api_host: posthogConfig.apiHost,
      ...posthogConfig.options,
    });

    this.initialized = true;
  }

  // page tracking
  capturePageView(path) {
    if (!this.initialized) return;
    posthog.capture("$pageview", { $current_url: path });
  }

  // user identification
  identify(userId, properties = {}) {
    if (!this.initialized) return;
    posthog.identify(userId, properties);
  }

  // user properties
  setPersonProperties(properties) {
    if (!this.initialized) return;
    posthog.setPersonProperties(properties);
  }

  // custom events
  track(eventName, properties = {}) {
    if (!this.initialized) return;
    posthog.capture(eventName, properties);
  }

  // auth events
  trackSignIn(method = "unknown") {
    this.track("user_signed_in", { method });
  }

  trackSignUp(method = "unknown") {
    this.track("user_signed_up", { method });
  }

  trackSignOut() {
    this.track("user_signed_out");
  }

  // dashboard events
  trackDashboardView(dashboardType) {
    this.track("dashboard_viewed", { dashboard_type: dashboardType });
  }

  trackSettingsView(settingsPage) {
    this.track("settings_viewed", { settings_page: settingsPage });
  }

  // feature usage
  trackFeatureUsed(featureName, properties = {}) {
    this.track("feature_used", { feature_name: featureName, ...properties });
  }

  // error tracking
  trackError(error, context = {}) {
    this.track("error_occurred", {
      error_message: error.message,
      error_stack: error.stack,
      ...context,
    });
  }

  // reset user data (on logout)
  reset() {
    if (!this.initialized) return;
    posthog.reset();
  }

  // get the posthog instance for advanced usage
  getInstance() {
    return this.initialized ? posthog : null;
  }
}

// create singleton instance
const posthogService = new PostHogService();

export default posthogService;
